/**
 * Retrieves an object's description
 * @param {Object} object
 * @return {Object} description
 */
function describe(object) {
  return Object.getOwnPropertyNames(object).reduce((desc, key) => {
    desc[key] = Object.getOwnPropertyDescriptor(object, key);
    return desc;
  }, Object.create(null));
}

/**
 * Inherits from superCtor to ctor.
 *
 * @param {Function} ctor
 * @param {Function} superCtor
 * @return {Object}
 */
function inherit(ctor, superCtor) {
  ctor.prototype = Object.create(superCtor.prototype, describe(ctor.prototype));
}

export { inherit };
